import React from "react";
import { Switch, Route } from "react-router-dom";
import { Header } from "./common/components/Header/header";
import HardwareDetailsPage from "./pages/hardware-details/hardware-details-page";
import SearchResultsHardwarePage from "./pages/hardware-search/hardware-search-page";
import OrdersPage from "./pages/orders/orders-page";
import OrderConfirmationPage from "./pages/confirmation/order-confirmation-page";
import CheckoutPage from "./pages/checkout/checkout-page";
import NotFoundPage from "./pages/not-found/not-found-page";
import { Paths } from "./common/paths/paths";

const App: React.FC = () => {
  return (
    <>
      <Header />
      <Switch>
        <Route exact path={Paths.search.url} component={SearchResultsHardwarePage} />
        <Route exact path={Paths.orders.url} component={OrdersPage} />
        <Route exact path={Paths.detailsPage.url} component={HardwareDetailsPage} />
        <Route exact path={Paths.checkout.url} component={CheckoutPage} />
        <Route exact path={Paths.confirmation.url} component={OrderConfirmationPage} />
        <Route path={Paths.notFound.url} component={NotFoundPage} />
      </Switch>
    </>
  );
};

export default App;
